import { render, staticRenderFns } from "./WealthSegmentation.vue?vue&type=template&id=82940d68"
import script from "./WealthSegmentation.vue?vue&type=script&lang=js"
export * from "./WealthSegmentation.vue?vue&type=script&lang=js"
import style0 from "./WealthSegmentation.vue?vue&type=style&index=0&id=82940d68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports